// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-popup {
  width: 900px;
  background-color: #fff;
  right: -259px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  height: 73vh;
  overflow: hidden; /* Hide overflow for the entire popup */
  position: absolute;
}

.handlercard {
  border-radius: 0% !important;
  font-size: medium;
  font-family: "FontAwesome";
  color: white;
  margin-bottom: 8px;
  position: sticky;
  z-index: 1;
  top: 0;
  overflow-x: auto;
}

.footer {
  position: sticky;
  z-index: 1;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  overflow: hidden; /* Hide overflow for the footer */
}

.modal-footer button {
  z-index: 2;
}

.modal-footer button i {
  margin-right: 0.5rem;
}

.modal-footer button:focus {
  outline: none;
}

.content-section {
  height: calc(100% - 40px - 40px);
  overflow-y: auto; /* Add scroll only for content section */
  overflow-x: hidden;
}

.contentpadding {
  padding-left: 10px;
  padding-right: 10px;
}

.searchcard {
  border-radius: 2px;
  background-color: #ebebeb;
  font-size: 11px;
  padding-bottom: 1%;
}

.leftcol {
  background-color: #f2f2f2;
}

.listcard {
  border-radius: 2px;
  height: 70px;
}

.form-control {
  border-radius: 5px !important;
  font-size: 12px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.autocomplete-container .input-container input {
  border-color: rgba(120, 130, 140, 0.2);
  height: 20px !important;
  width: 100% !important;
}

.font_size {
  font-size: 12px !important;
}

.brighter-placeholder::placeholder {
  color: #322e2e;
  opacity: 0.8;
}

.logdatacss {
  max-height: 15vh;
  overflow-y: auto;
  display: inline-block;
}

.text-ellipsis {
  white-space: nowrap !important;
  width: 85% !important;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
}

.space {
  text-align: end;
  padding-right: 0%;
}

.handlercard {
  border-radius: 0% !important;
  font-size: medium;
  font-family: "FontAwesome";
  color: white;
  margin-bottom: 8px;
}

.iconstyle {
  color: rgb(18, 154, 179);
  margin-top: -2px;
  cursor: pointer;
}

.failurelistheader {
  background-color: #007887;
  font-size: 12px;
  color: white;
  font-family: Montserrat;
}`, "",{"version":3,"sources":["webpack://./src/app/nonvitalcore/nonvitalcore.component.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,sBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA,EAAA,uCAAA;EACA,kBAAA;AADF;;AAIA;EACE,4BAAA;EACA,iBAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,MAAA;EACA,gBAAA;AADF;;AAIA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA,EAAA,iCAAA;AADF;;AAIA;EACE,UAAA;AADF;;AAIA;EACE,oBAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,gCAAA;EACA,gBAAA,EAAA,wCAAA;EACA,kBAAA;AADF;;AAIA;EACE,kBAAA;EACA,mBAAA;AADF;;AAIA;EACE,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,kBAAA;EACA,YAAA;AADF;;AAIA;EACE,6BAAA;EACA,0BAAA;EACA,wCAAA;AADF;;AAKA;EACE,sCAAA;EACA,uBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,0BAAA;AAFF;;AAKA;EACE,cAAA;EACA,YAAA;AAFF;;AAOA;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;AAJF;;AAQA;EACE,8BAAA;EACA,qBAAA;EACA,kCAAA;EACA,2BAAA;AALF;;AAQA;EACE,eAAA;EACA,iBAAA;AALF;;AAQA;EACE,4BAAA;EACA,iBAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;AALF;;AAQA;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;AALF;;AAQA;EACE,yBAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;AALF","sourcesContent":["@import \"../../variables.scss\";\r\n\r\n.custom-popup {\r\n  width: 900px;\r\n  background-color: #fff;\r\n  right: -259px;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  position: fixed;\r\n  height: 73vh;\r\n  overflow: hidden; /* Hide overflow for the entire popup */\r\n  position: absolute;\r\n}\r\n\r\n.handlercard {\r\n  border-radius: 0% !important;\r\n  font-size: medium;\r\n  font-family: \"FontAwesome\";\r\n  color: white;\r\n  margin-bottom: 8px;\r\n  position: sticky;\r\n  z-index: 1;\r\n  top: 0;\r\n  overflow-x: auto;\r\n}\r\n\r\n.footer {\r\n  position: sticky;\r\n  z-index: 1;\r\n  bottom: 0;\r\n  width: 100%;\r\n  background-color: #fff;\r\n  overflow: hidden; /* Hide overflow for the footer */\r\n}\r\n\r\n.modal-footer button {\r\n  z-index: 2;\r\n}\r\n\r\n.modal-footer button i {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.modal-footer button:focus {\r\n  outline: none;\r\n}\r\n\r\n.content-section {\r\n  height: calc(100% - 40px - 40px);\r\n  overflow-y: auto; /* Add scroll only for content section */\r\n  overflow-x: hidden;\r\n}\r\n\r\n.contentpadding{\r\n  padding-left: 10px;\r\n  padding-right: 10px;\r\n}\r\n\r\n.searchcard {\r\n  border-radius: 2px;\r\n  background-color: #ebebeb;\r\n  font-size: 11px;\r\n  padding-bottom: 1%;\r\n}\r\n\r\n.leftcol {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\n.listcard {\r\n  border-radius: 2px;\r\n  height: 70px;\r\n}\r\n\r\n.form-control {\r\n  border-radius: 5px !important;\r\n  font-size: 12px !important;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n\r\n}\r\n\r\n.autocomplete-container .input-container input {\r\n  border-color: rgba(120, 130, 140, .2);\r\n  height: 20px !important;\r\n  width: 100% !important;\r\n}\r\n\r\n.font_size {\r\n  font-size: 12px !important;\r\n}\r\n\r\n.brighter-placeholder::placeholder {\r\n  color: #322e2e;\r\n  opacity: 0.8;\r\n \r\n}\r\n\r\n\r\n.logdatacss {\r\n  max-height: 15vh;\r\n  overflow-y: auto;\r\n  display: inline-block;\r\n}\r\n\r\n\r\n.text-ellipsis {\r\n  white-space: nowrap !important;\r\n  width: 85% !important;\r\n  text-overflow: ellipsis !important;\r\n  overflow: hidden !important;\r\n}\r\n\r\n.space {\r\n  text-align: end;\r\n  padding-right: 0%;\r\n}\r\n\r\n.handlercard {\r\n  border-radius: 0% !important;\r\n  font-size: medium;\r\n  font-family: 'FontAwesome';\r\n  color: white;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.iconstyle {\r\n  color: rgb(18, 154, 179);\r\n  margin-top: -2px;\r\n  cursor: pointer;\r\n}\r\n\r\n.failurelistheader {\r\n  background-color: #007887;\r\n  font-size: 12px;\r\n  color: white;\r\n  font-family: Montserrat;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
